import React from "react";
import { useAccessibility } from "@/contexts/AccessibilityContext";
import { useT } from "@/lib/i18n";
import { Type } from "lucide-react";

const LABELS = {
  normal: "A",
  large: "A+",
  xl: "A++",
};

const TITLES = {
  normal: "a11y.size.normal",
  large: "a11y.size.large",
  xl: "a11y.size.xl",
};

export default function TextSizeToggle() {
  const { textSize, cycle } = useAccessibility();
  const t = useT();
  return (
    <button
      onClick={cycle}
      data-testid="text-size-toggle"
      data-text-size={textSize}
      title={`${t("a11y.cycle")} — ${t(TITLES[textSize])}`}
      aria-label={`${t("a11y.cycle")} — ${t(TITLES[textSize])}`}
      className="p-2 rounded-md bg-[#0B1221] border border-[#1E293B] hover:border-[#334155] flex items-center gap-1.5 transition-colors min-h-[44px] min-w-[44px]"
    >
      <Type className="w-4 h-4 text-[#94A3B8]" />
      <span className="font-display font-bold text-[#F8FAFC] text-sm leading-none">{LABELS[textSize]}</span>
    </button>
  );
}
